export interface AiExecutionMetadata {
  aiCredentialSource?: string | null;
  aiCredentialAlias?: string | null;
  aiProvider?: string | null;
  aiModel?: string | null;
  aiResponseMode?: string | null;
}
// Display only named non-secret fields; never stringify an API object.
export function aiSourceLabel(m: AiExecutionMetadata): string | null {
  if (!m.aiCredentialSource) return null;
  if (m.aiResponseMode === "approval_pending") return "Approval pending";
  if (m.aiResponseMode === "provider_error") return "Provider error";
  if (m.aiCredentialSource === "bot") return `Bot key${m.aiCredentialAlias ? ` · ${m.aiCredentialAlias}` : ""}`;
  if (m.aiCredentialSource === "organization_default") return "Organization default";
  return "Provider unavailable";
}
